import { spawn } from 'redux-saga/effects';

import { watchGetCategories } from './getCategories';

export default function* saga() {
  yield spawn(watchGetCategories);
}
